import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { IoMdMenu } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import { motion, AnimatePresence } from "framer-motion";
import logo from ".././assets/logo.png";
import AppointmentModal from "./AppointmentModal";

const items = [
  { id: 1, name: "হোম", link: "/" },
  { id: 2, name: "আমাদের সম্পর্কে", link: "/qs-academy/about/" },
  { id: 3, name: "রিভাইভ টেস্ট", link: "/qs-academy/test/thought" },
  { id: 4, name: "স্মার্ট স্কুল", link: "/qs-academy/smart-school/" },
  { id: 5, name: "ট্রেনিং", link: "/qs-academy/test-learning/teacher-traning" },
  { id: 6, name: "কোর্সে’স", link: "/qs-academy/course/" },
  { id: 8, name: "বুক স্টোর", link: "/qs-academy/bookstore/" },
  { id: 9, name: "ইভেন্ট’স", link: "/qs-academy/events/" },
];

const Navbar = () => {
  const [menu, setMenu] = useState(false);
  const [active, setAcitve] = useState("/");
  const [isFixed, setIsFixed] = useState(false);
  const [navHeight, setNavHeight] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const navRef = useRef(null);
  const location = useLocation();

  const role = 5;

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      setIsFixed(scrolled >= 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (navRef.current) {
      setNavHeight(navRef.current.offsetHeight);
    }

    const path = location.pathname;
    if (path === "/qs-academy/home/details") {
      setAcitve("/");
    } else if (path.startsWith("/qs-academy/course/details")) {
      setAcitve("/qs-academy/course/");
    } else if (path.startsWith("/qs-academy/bookstore")) {
      setAcitve("/qs-academy/bookstore/");
    } else {
      setAcitve(path);
    }
  }, [location]);

  return (
    <>
      <AnimatePresence>
        {isFixed && <div style={{ height: `${navHeight}px` }} />}
        <motion.div
          ref={navRef}
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
          className={`w-full flex justify-center items-center py-2 fixed-transition ${
            isFixed ? "fixed top-0 left-0 z-50 bg-[#00294B] shadow-md" : "static"
          }`}
          style={{ transition: "all 0.4s ease-in-out" }}
        >
          <div className="container flex justify-between items-center relative">
            <Link to="/" className="sm:w-[7rem] w-[5rem]">
              <img src={logo} alt="Logo" />
            </Link>

            <div className="lg:flex hidden items-center gap-4">
              {items.map((item) => (
                <Link
                  key={item.id}
                  to={item.link}
                  className={`text-xl font-semibold capitalize transition-all duration-300 ease-linear ${
                    active === item.link
                      ? "text-[#22BEFF]"
                      : "text-white hover:text-[#00E573]"
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>

            <div className="flex items-center gap-4">
              {role === 5 ? (
                <button
                  className="sm:px-5 px-4 sm:py-3 py-2 bg-[#22beff] text-sm font-medium rounded-lg whitespace-nowrap text-[#081A28] hover:text-white cursor-pointer"
                  onClick={() => setShowModal(true)}
                >
                  অ্যাপয়েন্টমেন্ট
                </button>
              ) : (
                <Link
                  to="/qs-academy/signin/"
                  className="sm:px-5 px-4 sm:py-3 py-2 bg-[#22beff] text-sm font-medium rounded-lg hover:text-[#081A28] whitespace-nowrap"
                >
                  Sign in
                </Link>
              )}

              <span
                className="text-4xl font-bold text-white cursor-pointer flex lg:hidden"
                onClick={() => setMenu(!menu)}
              >
                {menu ? <RxCross2 /> : <IoMdMenu />}
              </span>
            </div>

            <AnimatePresence>
              {menu && (
                <motion.div
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3 }}
                  className="absolute top-[5rem] left-1/2 transform -translate-x-1/2 w-full bg-[#00294B] rounded-md lg:hidden flex flex-col gap-2 p-4 z-50"
                >
                  {items.map((item) => (
                    <Link
                      key={item.id}
                      to={item.link}
                      className="text-base font-medium capitalize transition-all duration-300 ease-linear text-white hover:text-[#00E573] border-b border-[#343a40] pb-2"
                    >
                      {item.name}
                    </Link>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </motion.div>
      </AnimatePresence>

      {/* -------- MODAL -------- */}
      <AppointmentModal showModal={showModal} setShowModal={setShowModal}/>
      
    </>
  );
};

export default Navbar;
